/* eslint-disable @typescript-eslint/no-explicit-any */
import { PortfolioYears } from 'admin/pages/ManageAccounts/CustomQuestions/api';

export const YEAR_CHOICES_PLACEHOLDER = 'Add new year';
export const FEEDBACK_TYPE_PLACEHOLDER = 'Feedback Type';
export const DEFAULT_PORTFOLIO_STATUS = 'Active';
export const TIMELINE_CHOICES = [
  { id: 'invitation_sent', name: 'Invitation sent' },
  { id: 'allocate_investment', name: 'Allocate investment' },
  { id: 'submit_for_feedback', name: 'Submit for feedback' },
  { id: 'resolve_feedback', name: 'Resolve feedback' },
  { id: 'publish_report', name: 'Publish report' },
  { id: 'interim_report_update', name: 'Interim report update' },
  { id: 'finalize_report', name: 'Finalize report' },
];

export const validationSchema = (values: any, currentNames: any[]) => {
  const errors: any = {};
  if (!values.name) errors.name = 'Select a name';
  // if (!values.description) errors.description = 'Select a description';
  // if (!values.services || values.services.length === 0) {
  //   errors.services = 'Select an impact model';
  // }
  if (!values.years || values.years.length === 0) {
    errors.years = 'At least one year is required';
  }
  if (values.name && currentNames.indexOf(values.name.toLowerCase()) > -1) {
    errors.name =
      'There is another portfolio with the same name on this account.';
  }
  return errors;
};

export const getServicesName = (servicesList: any[]) => {
  return servicesList.map(sr => sr.name);
};

export const thisYear = new Date().getFullYear();
// Years range from 2015 through (thisYear + 10) inclusive so users always have
// at least 10 future years available when adding a portfolio year.
export const FUTURE_YEAR_OFFSET = 10;
export const yearsChoices = new Array(thisYear + FUTURE_YEAR_OFFSET + 1 - 2015)
  .fill(null)
  .map((_, index) => 2015 + index);

interface EditPortfolio {
  name: string;
  description: string;
  years: PortfolioYears;
  services: (string | undefined)[];
}

const compareYears = (
  a: EditPortfolio['years'][number],
  b: EditPortfolio['years'][number],
): boolean => {
  return (
    a.report_date_1 === b.report_date_1 &&
    a.report_date_2 === b.report_date_2 &&
    a.report_date_3 === b.report_date_3 &&
    a.report_date_4 === b.report_date_4 &&
    a.report_date_5 === b.report_date_5 &&
    a.report_date_6 === b.report_date_6 &&
    a.report_date_7 === b.report_date_7 &&
    a.report_date_8 === b.report_date_8
  );
};

export const comparePortfolios = (
  a: EditPortfolio,
  b: EditPortfolio,
): boolean => {
  if (a.years.length !== b.years.length) return false;
  if (a.description !== b.description) return false;
  if (a.name !== b.name) return false;
  if (a.services.length !== b.services.length) return false;
  if (!a.services.every((x, i) => x === b.services[i])) return false;
  for (let i = 0; i < a.years.length; i++) {
    if (!compareYears(a.years[i], b.years[i])) return false;
  }
  return true;
};
